import React, { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import { createState, useState, Downgraded } from '@hookstate/core';
import {
    Box,
    Grid,
    TextField,
    Paper,
    InputLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Card,
    CardContent,
    Typography,
    Checkbox,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
// import stores
import { updateModuleState } from '../../../stores/eventStore';
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../../../sharedcomponents/title/title';
import AirTransportIcon from '../../../sharedcomponents/customIcons/airTransportIcon';
import AppBarHeader from '../../../sharedcomponents/appbarHeader/appbarHeader';
import ParticipantAutoList from '../../../sharedcomponents/participantAutoList/participantAutoList';
import { useAgentState } from '../../../hookState/AgentState';
import moment from 'moment';
import AppConstants from '../../../constants/appConstants';
import PhoneNumber from '../../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../../sharedcomponents/datePicker';
import dayjs from 'dayjs';

const useStyles = makeStyles(() => ({
    titleContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: '0px',
    },
    selectionContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    contentRoot: {
        paddingBottom: '0px !important',
        margin: 0,
    },
}));

const FieldContainer = (props) => {
    const [formatmindate, setformatmidate] = React.useState('');
    const [formatmaxdate, setformatmaxdate] = React.useState('');
    const [datePicker, setdatepicker] = React.useState(null);
    const [disabledDates, setdisabledDates] = React.useState('');

    const handleDates = () => {
        if (
            props.field2 &&
            props.minDate !== '' &&
            props.maxDate !== '' &&
            props.minDate !== undefined &&
            props.minDate !== undefined
        ) {
            if (props.field2 === 'arrivalDate') {
                setformatmidate(props.minDate[0]);
                setformatmaxdate(props.maxDate[0]);
            } else if (props.field2 === 'departureDate') {
                setformatmidate(props.minDate[0]);
                setformatmaxdate(props.maxDate[0]);
            }
        }
        if (props.fromDates) {
            if (props.field2 === 'arrivalDate') {
                setdisabledDates(props.fromDates);
            }
        }
        if (props.toDates) {
            if (props.field2 === 'departureDate') {
                setdisabledDates(props.toDates);
            }
        }

        if (['dob', 'arrivalDate', 'departureDate'].includes(props.field2)) {
            setdatepicker(props.value2);
        }
    };

    useEffect(() => {
        handleDates();
    }, [props]);

    return (
        <>
            {props.type1 === 'text' ? (
                <TextField
                    size="small"
                    required={props.required1 ? props.required1 : false}
                    label={props.label1}
                    type={props.type1}
                    value={props.value1}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(event) =>
                        props.index != undefined
                            ? props.onChange1(
                                props.stateobj,
                                props.field1,
                                event.target.value,
                                props.index
                            )
                            : props.onChange1(
                                props.stateobj,
                                props.field1,
                                event.target.value,
                                null
                            )
                    }
                    inputProps={{ maxLength: 50 }}
                />
            ) : null}
            {props.type1 === 'arrivaltext' ||
                props.type1 === 'departuretext' ? (
                <TextField
                    size="small"
                    required={props.required1 ? props.required1 : false}
                    label={props.label1}
                    type={props.type1}
                    value={props.value2}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(event) =>
                        props.index != undefined
                            ? props.onChange2(
                                props.stateobj,
                                props.field2,
                                event.target.value,
                                props.index
                            )
                            : props.onChange2(
                                props.stateobj,
                                props.field2,
                                event.target.value,
                                null
                            )
                    }
                    inputProps={{ maxLength: 260 }}
                    multiline
                    rows={3}
                />
            ) : null}

            {props.type2 === 'text' ? (
                <TextField
                    size="small"
                    required={props.required2 ? props.required2 : false}
                    label={props.label2}
                    type={props.type2}
                    value={props.value2}
                    InputProps={props.inputProps ? props.inputProps : {}}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{ maxLength: 50 }}
                    onKeyDown={(event) => {
                        if (props.type2 === 'number') {
                            if (
                                event.key != 'ArrowUp' &&
                                event.key != 'ArrowDown' &&
                                event.key != 'Enter'
                            )
                                event.preventDefault();
                        }
                    }}
                    onChange={(event) => {
                        let str = event.target.value;
                        str = str.replace(/^\s+/g, '');
                        props.index != undefined
                            ? props.onChange2(
                                props.stateobj,
                                props.field2,
                                str,
                                props.index
                            )
                            : props.onChange2(
                                props.stateobj,
                                props.field2,
                                str,
                                null
                            );
                    }}
                    sx={{
                        maxWidth:
                            props.type2 === 'number'
                                ? { xs: '100%', sm: '270px', md: '270px' }
                                : '100%',
                    }}
                    error={props.label1 === "Person Name" && props.personErr ? true : false}
                    helperText={
                        props.label1 === "Person Name" && props.personErr ? props.personErr : ''
                    }
                />
            ) : props.type2 == 'arrivaltext' ||
                props.type2 == 'departuretext' ? null : props.type2 === 'date' ? (
                    <MUIDatePicker
                        label={props.label2}
                        value={
                            datePicker === null ||
                                datePicker === undefined ||
                                datePicker === ''
                                ? props.value2
                                : datePicker
                        }
                        error={false}
                        setValue={(newValue) => {
                            props.index != undefined
                                ? props.onChange2(
                                    props.stateobj,
                                    props.field2,
                                    newValue,
                                    props.index
                                )
                                : props.onChange2(
                                    props.stateobj,
                                    props.field2,
                                    newValue,
                                    null
                                );
                        }}
                        disablePast={
                            props.label2 == 'DOB'
                                ? false
                                : props.transitInfo &&
                                    props.transitInfo.draftTransportID > 0
                                    ? false
                                    : true
                        }
                        minDate={
                            props.label2 == 'DOB*'
                                ? ''
                                : formatmindate && dayjs(formatmindate)
                        }
                        maxDate={
                            props.label2 == 'DOB*'
                                ? ''
                                : formatmaxdate && dayjs(formatmaxdate)
                        }
                        disabledDates={
                            props.label2 !== 'DOB*' && disabledDates !== undefined
                                ? disabledDates
                                : []
                        }
                        disabled={props.dateDisabled}
                        disableFuture={props.label2 == 'DOB' ? true : false}
                        disableallDates={props.disableallDates ? true : false}
                    />
                ) : props.type2 === 'select' ? (
                    <FormControl fullWidth={true} size="small">
                        <InputLabel id="demo-simple-select-label">
                            {props.label2}
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={props.value2}
                            label={props.label2}
                            disabled={props.disabled2}
                            onChange={(event) => {
                                let value = event.target.value;

                                props.index != undefined
                                    ? props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        props.index
                                    )
                                    : props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        null
                                    );
                            }}>
                            {passengerCount.map((option) => (
                                <MenuItem
                                    key={`passanger_${option}`}
                                    value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                ) : props.type2 === 'ticketSelect' ? (
                    <FormControl
                        fullWidth={true}
                        size="small"
                        required={props.required2 ? props.required2 : false}>
                        <InputLabel id="demo-simple-select-label">
                            {props.label2}
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={`${props.value2}`}
                            label={props.label2}
                            disabled={props.disabled2}
                            onChange={(event) => {
                                let value = event.target.value;

                                props.index != undefined
                                    ? props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        props.index
                                    )
                                    : props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        null
                                    );
                            }}>
                            {ticketType.map((item) => (
                                <MenuItem
                                    key={`ticket_${item.key}`}
                                    value={item.key}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                ) : props.type2 === 'pnumber' ? (
                    <PhoneNumber
                        // name={'ticketContact'}
                        placeholder={props.label1}
                        value={props.value2}
                        onChange={(event) => {
                            let str = event;
                            str = str.replace(/^\s+/g, '');
                            props.index != undefined
                                ? props.onChange2(
                                    props.stateobj,
                                    props.field2,
                                    str,
                                    // e.target.value,
                                    props.index
                                )
                                : props.onChange2(
                                    props.stateobj,
                                    props.field2,
                                    str,
                                    // e.target.value,
                                    null
                                );
                        }}
                        required={true}
                    />
                ) : props.type2 === 'genderSelect' ? (
                    <FormControl
                        // fullWidth={true}
                        // width="25%"
                        size="small"
                        required={props.required2 ? props.required2 : false}>
                        <InputLabel id="demo-simple-select-label">
                            {props.label2}
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={`${props.value2}`}
                            label={props.label2}
                            disabled={props.disabled2}
                            onChange={(event) => {
                                let value = event.target.value;

                                props.index != undefined
                                    ? props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        props.index
                                    )
                                    : props.onChange2(
                                        props.stateobj,
                                        props.field2,
                                        value,
                                        null
                                    );
                            }}>
                            {props.genderType.map((item) => (
                                <MenuItem
                                    key={`gender_${item.id}`}
                                    value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                ) : (
                <TextField
                    size="small"
                    id="time"
                    label={props.label2}
                    type="time"
                    value={props.value2}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    // inputProps={{
                    // step: 300, // 5 min
                    inputProps={props.value2 != null ? { className: 'has-value' } : {}}
                    sx={{ width: '100%' }}
                    onChange={(newValue) => {
                        if (newValue.target.value != '') {
                            newValue.target.classList.add('has-value');
                        }
                        else {
                            newValue.target.classList.remove('has-value');
                        }
                        props.onChange2(
                            props.stateobj,
                            props.field2,
                            newValue.target.value,
                            null
                        );
                    }}
                />
            )}
        </>
    );
};

const passengerCount = [1];
const ticketType = [
    { value: 'Business', key: 1 },
    { value: 'Economy', key: 2 },
];
// const genderType = [
//     { value: 'Male', key: 1 },
//     { value: 'Female', key: 2 },
// ];

const AirTransport = (props) => { 
    const createdByUserInfo = Helper.getStorage('userInfo'); 
    //const participantType = useState(null);
    const arrivalInfo = createState({
        draftTransportID: 0,
        draftAirTransportID: 0,
        eventID: 0,
        transportType: 'air',
        tripInfoType: 'arrival',
        //participantType: participantType.get(),
        isPrivate: false,
        totalPassengers: 1,
        ticketType: 0,
        peopleInfo: [
            {
                // name: agentState.visible.value
                //     ? gUserInfo.firstName + ' ' + gUserInfo.lastName
                //     : '',
                name: '',
                dob: null,
                passengerEmail: '',
                passengerContactNo: '',
                gender: 0,
                err: ''
            },
        ],
        departureAirport: '',
        arrivalAirport: '',
        arrivalDate: null,
        arrivalTime: null,
        departureDate: null,
        departureTime: null,
        arrivalAirline: '',
        arrivalFlightNo: '',
        arrivalComments: '',
        createdBy: 0,
        addedFor: 0,
        arrivalTsa:'',
    });

    const departureInfo = createState({
        draftTransportID: 0,
        draftAirTransportID: 0,
        eventID: 0,
        transportType: 'air',
        tripInfoType: 'departure',
        //participantType: participantType.get(),
        isPrivate: false,
        totalPassengers: 1,
        ticketType: 0,
        peopleInfo: [
            {
                // name: agentState.visible.value
                //     ? gUserInfo.firstName + ' ' + gUserInfo.lastName
                //     : '',
                name: '',
                dob: null,
                passengerEmail: '',
                passengerContactNo: '',
                gender: 0,
                err: ''
            },
        ],
        departureAirport: '',
        arrivalAirport: '',
        departureDate: null,
        departureTime: null,
        arrivalDate: null,
        arrivalTime: null,
        departureAirline: '',
        departureFlightNo: '',
        departureComments: '',
        createdBy: 0,
        addedFor: 0,
        departureTsa:''
    });

    const classes = useStyles();
    // let params = useParams();
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [isGroundTransport, setIsGroundTransport] = React.useState(null);
    const [pickupAddress, setPickupAddress] = React.useState('');
    const [dropoffAddress, setDropoffAddress] = React.useState('');
    const departureState = useState(departureInfo);
    const arrivalState = useState(arrivalInfo);

    const tripType = useState(null);
    const infoType = useState('arrival');
    const genderType = useState([])
    const currentTransportInfo = useState(null);
    const disableButton = useState(false);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const originalBusinessTickets = useState(0);
    const originalEconomyTickets = useState(0);
    const prevTransInfo = useState(null);
    // const noOfBusinessTicket = useState(0);
    // const noOfEconomyTicket = useState(0);
    //
    const totalBusinessTickets = useState(0);
    const totalEconomyTickets = useState(0);
    const remainingArrivalBusinessTickets = useState(0);
    const remainingArrivalEconomyTickets = useState(0);
    const remainingDepartureBusinessTickets = useState(0);
    const remainingDepartureEconomyTickets = useState(0);
    const remainingGroundTransportTicket = useState(0);    
    const [minDate, setminDate] = React.useState([]);
    const [maxDate, setMaxDate] = React.useState([]);
    const [fromDates, setfromDates] = React.useState([]);
    const [toDates, settoDates] = React.useState([]);
    const [dateDOBDisabled, setDateDOBDisabled] = React.useState(false);
    const [dateDisabled, setDateDisabled] = React.useState(false);
    const [disableallDates, setdisableallDates] = React.useState(false);

    const configDetails = useState([]);
    const arrivalDates = useState([]);
    const departureDates = useState([]);

    const [participantList, setParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);

    const getLocalEST = (date, settime, field) => {
        return date && settime
            ? `${Helper.FormatYearDate(date)}T${settime}`
            : field == 'arrivalTime'
                ? `${Helper.FormatYearDate(date)}T23:59`
                : `${Helper.FormatYearDate(date)}T00:00`;
    };

    const setInfo = (
        stateObj,
        dateField1,
        timeField1,
        dateField2,
        timeField2
    ) => {
        let stateInfo = stateObj.attach(Downgraded).get();
        if (stateInfo[dateField1] !== null) {
            stateObj[dateField1].set(
                getLocalEST(
                    stateInfo[dateField1],
                    stateInfo[timeField1],
                    timeField1
                )
            );
        }
        if (stateInfo[dateField2] !== null) {
            stateObj[dateField2].set(
                getLocalEST(
                    stateInfo[dateField2],
                    stateInfo[timeField2],
                    timeField2
                )
            );
        }
        return stateInfo;
    };
    useEffect(() => {
        getParticipantList()
        fetchEventConfig();
    }, [])
    useEffect(() => {
        if (
            props.transitInfo &&
            (currentTransportInfo.get() == null ||
                currentTransportInfo.get().draftTransportID !=
                props.transitInfo.draftTransportID)
        ) {
            let transportInfo = props.transitInfo;
            
            if (transportInfo.draftTransportID > 0) {
                tripType.set('oneway');
                    if (transportInfo.addedFor && props.participantList) {
                        const index = props.participantList.findIndex(
                            (user) => user.userID == transportInfo.addedFor
                        );
                        if (index > -1) {
                            setParticipant(props.participantList[index]);
                            if(!transportInfo.isGroundTransport){ 
                                if (
                                    transportInfo.peopleInfo &&
                                    transportInfo.peopleInfo[0].dob == ''
                                ) {
                                    getParticipantDob(
                                        props.participantList[index].userID
                                    );
                                }
                            }
                        }
                    } else {
                        getParticipantListIfNotFound(transportInfo)
                    }
                
                transportInfo.arrivalTime = `${Helper.FormatTime24(
                    transportInfo.arrivalDate
                )}`;
                setIsGroundTransport(transportInfo.isGroundTransport);
                setPickupAddress(transportInfo.groundPickupAddress);
                setDropoffAddress(transportInfo.groundDropoffAddress);
                transportInfo.isGroundTransport = transportInfo.isGroundTransport;                
                transportInfo.departureTime = transportInfo.departureDate
                    ? `${Helper.FormatTime24(transportInfo.departureDate)}`
                    : ''; 
                infoType.set(transportInfo.tripInfoType);
                //participantType.set(transportInfo.participantType);
                if (transportInfo.tripInfoType == 'arrival') {
                    transportInfo.arrivalAirline = transportInfo.airline;
                    transportInfo.arrivalFlightNo = transportInfo.flightNo;
                    transportInfo.arrivalComments = transportInfo.comments;
                    transportInfo.arrivalTsa = transportInfo.tsa;
                    arrivalState.set(transportInfo);
                } else {
                    transportInfo.departureAirline = transportInfo.airline;
                    transportInfo.departureFlightNo = transportInfo.flightNo;
                    transportInfo.departureComments = transportInfo.comments;
                    transportInfo.departureTsa = transportInfo.tsa;
                    departureState.set(transportInfo);
                }
                currentTransportInfo.set(transportInfo);
            }
        }
    }, [props]);
    const getParticipantListIfNotFound = (transportInfo) => {
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                    eventInfo.eventID
                )
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants)
                    const index = participants.findIndex(
                        (user) => user.userID == transportInfo.addedFor
                    );
                    if (index > -1) {
                        setParticipant(participants[index]);
                        const person = transportInfo.peopleInfo?.[0];
    
                        if (person && person.dob === '') {
                            getParticipantDob(participants[index].userID);
                        }
                        // if (
                        //     transportInfo.peopleInfo &&
                        //     transportInfo.peopleInfo[0].dob == ''
                        // ) {
                        //     getParticipantDob(
                        //         participants[index].userID
                        //     );
                        // }
                    }
                }
            });
        }
    }
    useEffect(() => {
        if (props.transitID != 0) {
            ApiHelper.get(APIURLConstants.GET_DRAFT_AIRTRANSPORT_ROW(props.transitID))
                .then((res) => {
                    if (res.data) {
                        let data = res.data;
                        let peopleData = [];
                        data.peopleInfo &&
                            data.peopleInfo.map((item) => {
                                let people = {
                                    name: item.name,
                                    dob: Helper.FormatDateOnly(item.dob),
                                    passengerContactNo: item.passengerContactNo,
                                    passengerEmail: item.passengerEmail,
                                    gender: item.gender
                                };

                                peopleData.push(people);
                            });
                        if ((agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo) || Helper.isEventStaff(agentInfo))) {
                            const eventid = data.eventID;
                            const userId = data.addedFor
                            ApiHelper.get(
                                APIURLConstants.GET_TAGID_BY_USERID(eventid, userId)
                            ).then((res) => {
                                let data = res.data;
                                let Tagsid = data[0].tagID.split(',');
                                if (data[0].tagID && data[0].tagID != null) {
                                    fetchEventConfig(Tagsid)
                                }
                                else {
                                    // setdisableallDates(true);
                                }
                            })
                        } else if (!(agentInfo && agentState.visible.value) && !(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                            const eventid = data.eventID;
                            const userId = data.addedFor
                            ApiHelper.get(
                                APIURLConstants.GET_TAGID_BY_USERID(eventid, userInfo.userID)
                            ).then((res) => {
                                let data = res.data;
                                let Tagsid = data[0].tagID.split(',');
                                if (data[0].tagID && data[0].tagID != null) {
                                    fetchEventConfig(Tagsid)
                                }
                                else {
                                    // setdisableallDates(true);
                                }
                            })
                        }

                        data.peopleInfo = peopleData;
                        prevTransInfo.set(data);
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                });
        }
    }, [props.transitID]);

    const getParticipantDob = (userID) => {
        ApiHelper.get(APIURLConstants.GET_USER(userID))
            .then((res) => {
                if (res.data) {
                    ApiHelper.get(
                        APIURLConstants.GET_TAGID_BY_USERID(eventInfo.eventID, userID)
                    ).then((res) => {
                        let data = res.data;
                        let Tagsid = data[0].tagID && data[0].tagID.split(',');
                        if (data[0].tagID && data[0].tagID != null) {
                            if (!(Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))) {
                                fetchEventConfig(Tagsid)
                            }
                        }
                        else {
                            // setdisableallDates(true);
                        }
                    })
                    let data = res.data;
                    if (data.dob == null) {
                        arrivalState.peopleInfo[0]['dob'].set(null);
                        departureState.peopleInfo[0]['dob'].set(null);
                    } else {
                        arrivalState.peopleInfo[0]['dob'].set(
                            dayjs(data.dob).format('YYYY-MM-DD')
                        );
                        departureState.peopleInfo[0]['dob'].set(
                            dayjs(data.dob).format('YYYY-MM-DD')
                        );
                        if (tripType.get() == 'round') {
                            setDateDOBDisabled(true)
                        }
                    }
                }
            })
            .catch((error) => {
                console.log("error", error);
                if (error.response && error.response.status === 401) {
                    showError('showError', 'Access denied')
                } else {
                    showError('showError', 'Error while creating request')
                }
            });
    };

    const fetchEventConfig = async (id) => {
        const eventID = eventInfo.eventID
        const moduleID = 1;
        const tagID = id
        ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(eventID))
            .then((res) => {
                let filData = res.data.filter((x) => x.moduleID == 20)
                filData.map((x) => {
                    genderType.set(JSON.parse(x.description))
                })
                if (
                    !Helper.isAdminUser(userInfo) &&
                    !Helper.isEventAdmin(userInfo)
                ) {
                    configDetails.set(res.data);
                    if (res.data.length > 0) {
                        arrivalDates.set(
                            res.data
                                .filter(
                                    (x) =>
                                        x.key.toLowerCase() ===
                                        'complemintarycheckin' ||
                                        x.key.toLowerCase() ===
                                        'forpurchasecheckin'
                                )
                                .map((y) =>
                                    Helper.FormatDate(
                                        moment(y.description).format()
                                    )
                                )
                        );
                        departureDates.set(
                            res.data
                                .filter(
                                    (x) =>
                                        x.key.toLowerCase() ===
                                        'complimentarycheckout'
                                )
                                .map((y) =>
                                    Helper.FormatDate(
                                        moment(y.description).format()
                                    )
                                )
                        );
                    }
                }
            })
        await ApiHelper.get(
            APIURLConstants.GET_EVENT_TAG_DATES(eventID, moduleID, tagID)
        )
            .then((res) => {
                if (res.data.length > 0) {
                    const data = res.data;
                    if (arrivalInfo.arrivalDate) {
                        setDateDisabled(false)
                        let minDates = [];
                        let maxDates = [];
                        let fromDate = [];
                        let toDate = [];

                        data.forEach((item) => {
                            const types = item.type === 1 ? 'Fixed' : 'Range';
                            if (types === 'Range') {
                                const fromDate = item.fromDate;
                                const toDate = item.toDate;

                                minDates.push(fromDate);
                                maxDates.push(toDate);
                            } else if (types === 'Fixed') {
                                fromDate.push(item.fromDate);
                                toDate.push(item.toDate);
                            }
                            else {
                                // setdisableallDates(true);
                            }
                        });
                        setfromDates(fromDate);
                        settoDates(toDate);
                        setminDate(minDates);
                        setMaxDate(maxDates);
                    }

                } else {
                    // setdisableallDates(true);
                    setDateDisabled(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => { 
        // console.log("props",props);
        
        //fetchEventConfig(gEventInfo.eventID);
        originalBusinessTickets.set(props.originalBusinessTickets);
        originalEconomyTickets.set(props.originalEconomyTickets);

        totalBusinessTickets.set(props.totalBusinessTickets);
        totalEconomyTickets.set(props.totalEconomyTickets);
        remainingArrivalBusinessTickets.set(
            props.remainingArrivalBusinessTickets
        );
        remainingArrivalEconomyTickets.set(
            props.remainingArrivalEconomyTickets
        );
        remainingDepartureBusinessTickets.set(
            props.remainingDepartureBusinessTickets
        );
        remainingDepartureEconomyTickets.set(
            props.remainingDepartureEconomyTickets
        );
        remainingGroundTransportTicket.set(
            props.remainingGroundTransportTicket
        )
        if (props && props.transitID == 0) {
            tripType.set('round');
            if (
                !Helper.isAdminUser(userInfo) &&
                !Helper.isEventAdmin(userInfo)
            ) {
                getParticipantDob(userInfo.userID);
            }
        }
    }, []);

    const resetState = () => {
        departureState.set({
            draftTransportID: 0,
            draftAirTransportID: 0,
            eventID: eventInfo.eventID,
            transportType: 'air',
            tripInfoType: 'departure',
            //participantType: participantType.get(),
            isPrivate: false,
            totalPassengers: 1,
            ticketType: 0,
            peopleInfo: [
                {
                    name: '',
                    dob: null,
                },
            ],
            departureAirport: '',
            arrivalAirport: '',
            departureDate: null,
            departureTime: null,
            arrivalDate: null,
            arrivalTime: null,
            departureAirline: '',
            departureFlightNo: '',
            departureComments: '',
            createdBy: userInfo.userID,
            // addedFor
            addedFor: userInfo.userID,
        });
        arrivalState.set({
            draftTransportID: 0,
            draftAirTransportID: 0,
            eventID: eventInfo.eventID,
            transportType: 'air',
            tripInfoType: 'arrival',
            //participantType: participantType.get(),
            isPrivate: false,
            totalPassengers: 1,
            ticketType: 0,
            peopleInfo: [
                {
                    name: '',
                    dob: null,
                },
            ],
            departureAirport: '',
            arrivalAirport: '',
            arrivalDate: null,
            arrivalTime: null,
            departureDate: null,
            departureTime: null,
            arrivalAirline: '',
            arrivalFlightNo: '',
            arrivalComments: '',
            createdBy: userInfo.userID,
            // addedFor
            addedFor: userInfo.userID,
        });
    };
    const getParticipantList = () => { 
        if (
            !Helper.isAdminUser(userInfo) ||
            !(userInfo.roles && Helper.isEventAdmin(userInfo)) || !(userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    };
    const showError = (variant, msg) => {
        props.setSnackBarProps({
            ...props.snackBarProps,
            openSnack: true,
            variant: variant,
            message: msg,
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(createdByUserInfo,userInfo,departureState.attach(Downgraded).get(), arrivalState.attach(Downgraded).get(),props);
        // return false
        const getTripType = tripType.get();
        const getInfoType = infoType.get();
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        arrivalState.createdBy.set(createdByUserInfo.userID);
        departureState.createdBy.set(createdByUserInfo.userID);
        arrivalState.addedFor.set(userInfo.userID);
        departureState.addedFor.set(userInfo.userID);
        if (Helper.isAdminUser(userInfo) || userInfo.roles && Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
            if (participant === null) {
                showError('error', 'please Select participant First')
                return;
            }
        }

        arrivalState.addedFor.set(
            participant
                ? participant.userID
                : arrivalState.addedFor.get()
                    ? arrivalState.addedFor.get()
                    : userInfo.userID
        );

        arrivalState.ticketType.set(arrivalState.ticketType.get())

        departureState.addedFor.set(
            participant
                ? participant.userID
                : departureState.addedFor.get()
                    ? departureState.addedFor.get()
                    : userInfo.userID
        );
        departureState.ticketType.set(departureState.ticketType.get())

        let requestObj = {};
        
        if(isGroundTransport) {
            const currTransportInfo = currentTransportInfo.get() &&
            currentTransportInfo.get();
            requestObj.arrivalInfo = {};
            requestObj.arrivalInfo.addedFor = participant
                ? participant.userID
                : userInfo.userID
            requestObj.arrivalInfo.createdBy = createdByUserInfo.userID;
            requestObj.arrivalInfo.eventID  = eventInfo.eventID;
            requestObj.arrivalInfo.isGroundTransport = isGroundTransport;
            requestObj.arrivalInfo.groundPickupAddress = pickupAddress;
            requestObj.arrivalInfo.groundDropoffAddress = dropoffAddress;
            requestObj.arrivalInfo.transportType = 'air';
            requestObj.arrivalInfo.tripInfoType = 'arrival'; 
            requestObj.arrivalInfo.totalPassengers = 1; 
            requestObj.arrivalInfo.draftTransportID = currTransportInfo ? currTransportInfo.draftTransportID : 0 ;
            requestObj.arrivalInfo.draftAirTransportID = currTransportInfo ? currTransportInfo.draftAirTransportID : 0;
            if (pickupAddress.trim() === '' ) {
                showError('error', 'Please Enter Pickup address')
                return false;
            }else if (dropoffAddress.trim() === '' ) {
                showError('error', 'Please Enter Drop-off address')
                return false;
            }else if (
                !Helper.isAdminUser(userInfo) &&
                !(
                    userInfo.roles &&
                    Helper.isEventAdmin(userInfo)
                ) &&
                !(
                    userInfo.roles &&
                    Helper.isEventStaff(userInfo)
                )
            ) {
                if (
                    isGroundTransport && !props.transitID &&
                    // arrivalState.attach(Downgraded).get().ticketType == 1 &&
                    remainingGroundTransportTicket.get() <= 0
                ) {
                    // showError('error', 'Business ticket limit exceeds!')
                    showError('error', 'Ground Transport ticket limit exceeds!')
                    return false;
                }
            }
        }else{
           
            let arrivalInfo = setInfo(
                arrivalState,
                'arrivalDate',
                'arrivalTime',
                'departureDate',
                'departureTime'
            );
            let departureInfo = setInfo(
                departureState,
                'arrivalDate',
                'arrivalTime',
                'departureDate',
                'departureTime'
            );
            if (props.transitID) {
                let nameValid1 = true;
                departureState.get().peopleInfo[0].name.split(' ').forEach(x => {
                    if (!Helper.isValidName(x) && infoType.get() === 'departure')
                        nameValid1 = false
                })
                // }
                let nameValid = true;
                // if (arrivalState.get().peopleInfo[0].name !== '') {
                arrivalState.get().peopleInfo[0].name.split(' ').forEach(x => {
                    if (!Helper.isValidName(x) && infoType.get() === 'arrival')
                        nameValid = false
                })
                // }
                if (!nameValid1) {
                    // departureState['peopleInfo'][0]['err'].set("Please Enter Valid Person Name");
                    showError('error', 'Please enter valid person name')
                    return false;
                }
                else if (!nameValid) {
                    // arrivalState['peopleInfo'][0]['err'].set("Please Enter Valid Person Name");
                    showError('error', 'Please enter valid person name')
                    return false;
                }
                else if (
                    infoType.get() === 'arrival' &&
                    (arrivalState.get().peopleInfo[0].passengerContactNo === null || !regex.test(arrivalState.get().peopleInfo[0].passengerContactNo))
                ) {
                    showError('error', 'Please enter valid contact number')
                    return false;
                }
                else if (
                    infoType.get() === 'departure' &&
                    (departureState.get().peopleInfo[0].passengerContactNo === null || !regex.test(departureState.get().peopleInfo[0].passengerContactNo))
                ) {
                    showError('error', 'Please enter valid contact number')
                    return false;
                }
                else if (
                    infoType.get() === 'arrival' &&
                    (arrivalState.get().peopleInfo[0].passengerEmail === null || !Helper.validEmail(arrivalState.get().peopleInfo[0].passengerEmail))
                ) {
                    showError('error', 'Please enter valid Email')
                    return false;
                }
                else if (
                    infoType.get() === 'departure' &&
                    (departureState.get().peopleInfo[0].passengerEmail === null || !Helper.validEmail(departureState.get().peopleInfo[0].passengerEmail))
                ) {
                    showError('error', 'Please enter valid Email')
                    return false;
                }
                else if (
                    infoType.get() === 'arrival' &&
                    arrivalState.get().peopleInfo[0].gender == 0 || arrivalState.get().peopleInfo[0].gender == null
                ) {
                    showError('error', 'Please select gender')
                    return false;
                }
                else if (
                    infoType.get() === 'departure' &&
                    departureState.get().peopleInfo[0].gender == 0 || departureState.get().peopleInfo[0].gender == null
                ) {
                    showError('error', 'Please select gender')
                    return false;
                } else if (
                    infoType.get().trim() === 'arrival' && (arrivalState.attach(Downgraded).get().arrivalTime === null || arrivalState.attach(Downgraded).get().arrivalTime === "")
                ) {
                    showError('error', 'Please select arrival time')
                    return false;
                } else if (
                    infoType.get().trim() === 'departure' && (departureState.attach(Downgraded).get().departureTime === null || departureState.attach(Downgraded).get().departureTime === "")
                ) {
                    showError('error', 'Please select departure time')
                    return false;
                }
            } else {
                if (tripType.get() === 'round') {
                    if (
                        arrivalState.arrivalDate.get() === null ||
                        departureState.departureDate.get() === null
                    ) {
                        showError('error', 'Please select dates')
                        return false;
                    }
                    let nameValid2 = true;
                    departureState.attach(Downgraded).get().peopleInfo[0]['name'].split(' ').forEach(x => {
                        if (!Helper.isValidName(x)) {
                            nameValid2 = false
                        }
                    })
                    if (!nameValid2
                    ) {
                        showError('error', 'Please Enter Valid Person Name.')
                        return false;
                    }
                    if (tripType.get() === 'round' && departureState.attach(Downgraded).get().peopleInfo[0]['dob'] == null) {
                        showError('error', 'Please select DOB')
                        return false;
                    }
                    if (
                        tripType.get() === 'round' &&
                        departureState.attach(Downgraded).get().departureDate ==
                        null
                    ) {
                        showError('error', 'Please select departure date')
                        return false;
                    }
                    if (
                        infoType.get() === 'round' &&
                        arrivalState.attach(Downgraded).get().arrivalDate == null
                    ) {
                        showError('error', 'Please select arrival date')
                        return false;
                    }
                    if (arrivalState.attach(Downgraded).get().arrivalTime === null || arrivalState.attach(Downgraded).get().arrivalTime === "") {
                        showError('error', 'Please select arrival time')
                        return false;
                    }
    
                    if (departureState.attach(Downgraded).get().departureTime === null || departureState.attach(Downgraded).get().departureTime === "") {
                        showError('error', 'Please select departure time')
                        return false;
                    }
    
                    // if (
                    //     tripType.get() === 'round' &&
                    //     departureState.attach(Downgraded).get().ticketType == 0
                    // ) {
                    //     showError('error', 'Please select ticket type')
                    //     return false;
                    // }
                    if (
                        tripType.get() === 'round' &&
                        departureState.get().peopleInfo[0].gender == 0
                    ) {
                        showError('error', 'Please select gender')
                        return false;
                    }
                    if (
                        tripType.get() === 'round' &&
                        !regex.test(departureState.get().peopleInfo[0].passengerContactNo)
                    ) {
                        showError('error', 'Please enter valid contact number')
                        return false;
                    }
                    if (
                        tripType.get() === 'round' &&
                        !Helper.validEmail(departureState.get().peopleInfo[0].passengerEmail)
                    ) {
                        showError('error', 'Please enter valid email')
                        return false;
                    }
                    // if (
                    //     tripType.get() === 'round' &&
                    //     arrivalState.attach(Downgraded).get().ticketType == 0
                    // ) {
                    //     showError('error', 'Please select ticket type')
                    //     return false;
                    // }
                    if (
                        tripType.get() === 'round' &&
                        departureState.get().peopleInfo[0].gender == 0
                    ) {
                        showError('error', 'Please select gender')
                        return false;
                    }
                    if (
                        tripType.get() === 'round' &&
                        !regex.test(departureState.get().peopleInfo[0].passengerContactNo)
                    ) {
                        showError('error', 'Please enter valid contact number')
                        return false;
                    }
                    if (
                        tripType.get() === 'round' &&
                        !Helper.validEmail(departureState.get().peopleInfo[0].passengerEmail)
                    ) {
                        showError('error', 'Please enter valid email')
                        return false;
                    }
                    // Comment ticket limit exceeds
                    if (
                        !Helper.isAdminUser(userInfo) &&
                        !(
                            userInfo.roles &&
                            Helper.isEventAdmin(userInfo)
                        ) &&
                        !(
                            userInfo.roles &&
                            Helper.isEventStaff(userInfo)
                        )
                    ) {
                        if (
                            tripType.get() === 'round' &&
                            // departureState.attach(Downgraded).get().ticketType ==
                            // 1 &&
                            remainingDepartureBusinessTickets.get() <= 0
                        ) {
                            // showError('error', 'Business Ticket limit exceeds!')
                            showError('error', 'Departure ticket limit exceeds!') 
                            return false;
                        }
    
                        // if (
                        //     tripType.get() === 'round' &&
                        //     departureState.attach(Downgraded).get().ticketType ==
                        //     2 &&
                        //     remainingDepartureEconomyTickets.get() <= 0 &&
                        //     remainingDepartureBusinessTickets.get() <= 0
                        // ) {
                        //     showError('error', 'Economy ticket limit exceeds!')
                        //     return false;
                        // }
                        if (
                            tripType.get() === 'round' &&
                            // arrivalState.attach(Downgraded).get().ticketType == 1 &&
                            remainingArrivalBusinessTickets.get() <= 0
                        ) {
                            // showError('error', 'Business ticket limit exceeds!')
                            showError('error', 'Arrival ticket limit exceeds!')

                            return false;
                        }
    
                        // if (
                        //     tripType.get() === 'round' &&
                        //     arrivalState.attach(Downgraded).get().ticketType == 2 &&
                        //     remainingArrivalEconomyTickets.get() <= 0 &&
                        //     remainingArrivalBusinessTickets.get() <= 0
                        // ) {
                        //     showError('error', 'Economy ticket limit exceeds!')
                        //     return false;
                        // }
                    }
                } else if (tripType.get() === 'oneway') {
                    if (infoType.get() === 'arrival') {
                        if (
                            arrivalState.arrivalDate.get() === null
                        ) {
                            showError('error', 'Please select arrival date')
                            return false;
                        }
                        if (infoType.get() === 'arrival' && arrivalState.attach(Downgraded).get().peopleInfo[0]['dob'] == null) {
                            showError('error', 'Please select DOB')
                            return false;
                        }
                        if (
                            infoType.get() === 'arrival' &&
                            arrivalState.attach(Downgraded).get().arrivalDate ==
                            null
                        ) {
                            showError('error', 'Please select arrival date')
                            return false;
                        }
                        if (
                            infoType.get() === 'arrival' &&
                            (arrivalState.attach(Downgraded).get().arrivalTime ==
                                null || arrivalState.attach(Downgraded).get().arrivalTime ==
                                '')
                        ) {
                            showError('error', 'Please select arrival time')
                            return false;
                        }
                        // if (
                        //     infoType.get() === 'arrival' &&
                        //     arrivalState.attach(Downgraded).get().ticketType == 0
                        // ) {
                        //     showError('error', 'Please select ticket type')
                        //     return false;
                        // }
                        if (
                            infoType.get() === 'arrival' &&
                            arrivalState.get().peopleInfo[0].gender == 0
                        ) {
                            showError('error', 'Please select gender')
                            return false;
                        }
                        if (
                            infoType.get() === 'arrival' &&
                            !regex.test(arrivalState.get().peopleInfo[0].passengerContactNo)
                        ) {
                            showError('error', 'Please enter valid contact number')
                            return false;
                        }
                        if (
                            infoType.get() === 'arrival' &&
                            !Helper.validEmail(arrivalState.get().peopleInfo[0].passengerEmail)
                        ) {
                            showError('error', 'Please enter valid email')
                            return false;
                        }
                        if (
                            !Helper.isAdminUser(userInfo) &&
                            !(
                                userInfo.roles &&
                                Helper.isEventAdmin(userInfo)
                            ) &&
                            !(
                                userInfo.roles &&
                                Helper.isEventStaff(userInfo)
                            )
                        ) {
                            if (
                                infoType.get() === 'arrival' &&
                                // arrivalState.attach(Downgraded).get().ticketType ==
                                // 1 &&
                                remainingArrivalBusinessTickets.get() <= 0
                            ) {
                                // showError('error', 'Business ticket limit exceeds!')
                                showError('error', 'Arrival ticket limit exceeds!')
                                return false;
                            }
    
                            // if (
                            //     infoType.get() === 'arrival' &&
                            //     arrivalState.attach(Downgraded).get().ticketType ==
                            //     2 &&
                            //     remainingArrivalEconomyTickets.get() <= 0 &&
                            //     remainingArrivalBusinessTickets.get() <= 0
                            // ) {
                            //     showError('error', 'Economy ticket limit exceeds!')
                            //     return false;
                            // }
                            // if (
                            //     infoType.get() === 'arrival' &&
                            //     arrivalState.attach(Downgraded).get().ticketType ==
                            //     2 &&
                            //     remainingArrivalEconomyTickets.get() <= 0 &&
                            //     remainingArrivalBusinessTickets.get() > 0 &&
                            //     remainingDepartureBusinessTickets.get() <= 0
                            // ) {
                            //     showError('error', 'Economy ticket limit exceeds!')
                            //     return false;
                            // }
                        }
                    }
                    if (infoType.get() === 'departure') {
                        if (
                            departureState.departureDate.get() === null
                        ) {
                            showError('error', 'Please select departure dates')
                            return false;
                        }
                        if (infoType.get() === 'departure' && departureState.attach(Downgraded).get().peopleInfo[0]['dob'] == null) {
                            showError('error', 'Please select DOB')
                            return false;
                        }
                        if (
                            infoType.get() === 'departure' &&
                            departureState.attach(Downgraded).get().departureDate ==
                            null
                        ) {
                            showError('error', 'Please select departure date')
                            return false;
                        }
                        // if (
                        //     infoType.get() === 'departure' &&
                        //     departureState.attach(Downgraded).get().ticketType == 0
                        // ) {
                        //     showError('error', 'Please select ticket type')
                        //     return false;
                        // }
                        // if (
                        //     infoType.get() === 'departure' &&
                        //     departureState.get().peopleInfo[0].gender == 0
                        // ) {
                        //     showError('error', 'Please select ticket type')
                        //     return false;
                        // }
                        if (
                            infoType.get() === 'departure' &&
                            !regex.test(departureState.get().peopleInfo[0].passengerContactNo)
                        ) {
                            showError('error', 'Please enter valid contact number')
                            return false;
                        }
                        if (
                            infoType.get() === 'departure' &&
                            !Helper.validEmail(departureState.get().peopleInfo[0].passengerEmail)
                        ) {
                            showError('error', 'Please enter valid email')
                            return false;
                        }
                        if (
                            !Helper.isAdminUser(userInfo) &&
                            !(
                                userInfo.roles &&
                                Helper.isEventAdmin(userInfo)
                            ) &&
                            !(
                                userInfo.roles &&
                                Helper.isEventStaff(userInfo)
                            )
                        ) {
                            if (
                                infoType.get() === 'departure' &&
                                // departureState.attach(Downgraded).get()
                                //     .ticketType == 1 &&
                                remainingDepartureBusinessTickets.get() <= 0
                            ) {
                                // showError('error', 'Business ticket limit exceeds!')
                                showError('error', 'Departure ticket limit exceeds!')
                                return false;
                            }
    
                            // if (
                            //     infoType.get() === 'departure' &&
                            //     departureState.attach(Downgraded).get()
                            //         .ticketType == 2 &&
                            //     remainingDepartureEconomyTickets.get() <= 0 &&
                            //     remainingDepartureBusinessTickets.get() <= 0
                            // ) {
                            //     showError('error', 'Economy ticket limit exceeds!')
                            //     return false;
                            // }
                            // if (
                            //     infoType.get() === 'departure' &&
                            //     departureState.attach(Downgraded).get()
                            //         .ticketType == 2 &&
                            //     remainingDepartureEconomyTickets.get() <= 0 &&
                            //     remainingDepartureBusinessTickets.get() > 0 &&
                            //     remainingArrivalBusinessTickets.get() <= 0
                            // ) {
                            //     showError('error', 'Economy ticket limit exceeds!')
                            //     return false;
                            // }
                        }
                        if (infoType.get() === 'departure' && (departureState.attach(Downgraded).get().departureTime === null || departureState.attach(Downgraded).get().departureTime === '')) {
                            showError('error', 'Please select departure time')
                            return false;
                        }
                    }
                }
            }
            if (getTripType == 'round') {
                if (
                    arrivalState.arrivalDate.get() === null ||
                    departureState.departureDate.get() === null
                ) {
                    showError('error', 'Please select dates.')
                    return false;
                }
                arrivalInfo.eventID = eventInfo.eventID;
                arrivalInfo = Helper.trimObject(arrivalInfo);
                if (arrivalInfo.departureAirport == arrivalInfo.arrivalAirport) {
                    showError('error', 'Arrival and departure airport should be different.')
                    return false;
                }
                requestObj.arrivalInfo = arrivalInfo;
                requestObj.arrivalInfo.airline = arrivalInfo.arrivalAirline;
                requestObj.arrivalInfo.flightNo = arrivalInfo.arrivalFlightNo;
                requestObj.arrivalInfo.comments = arrivalInfo.arrivalComments;
                requestObj.arrivalInfo.ticketType = arrivalInfo.ticketType;
                requestObj.arrivalInfo.tsa = arrivalInfo.arrivalTsa;

                departureInfo.eventID = eventInfo.eventID;
                departureInfo = Helper.trimObject(departureInfo);
                if (
                    departureInfo.departureAirport == departureInfo.arrivalAirport
                ) {
                    showError('error', 'Arrival and departure airport should be different')
                    return false;
                }
                requestObj.departureInfo = departureInfo;
                requestObj.departureInfo.airline = departureInfo.departureAirline;
                requestObj.departureInfo.flightNo = departureInfo.departureFlightNo;
                requestObj.departureInfo.comments = departureInfo.departureComments;
                requestObj.departureInfo.ticketType = departureInfo.ticketType;
                requestObj.departureInfo.tsa = departureInfo.departureTsa;
            } else {
                if (getInfoType === 'arrival') {
                    arrivalInfo.eventID = eventInfo.eventID;
                    arrivalInfo = Helper.trimObject(arrivalInfo);
                    if (
                        arrivalInfo.departureAirport == arrivalInfo.arrivalAirport
                    ) {
                        showError('error', 'Arrival and departure airport should be different')
                        return false;
                    }
                    requestObj.arrivalInfo = arrivalInfo;
                    requestObj.arrivalInfo.airline = arrivalInfo.arrivalAirline;
                    requestObj.arrivalInfo.flightNo = arrivalInfo.arrivalFlightNo;
                    requestObj.arrivalInfo.comments = arrivalInfo.arrivalComments;
                    requestObj.arrivalInfo.ticketType = arrivalInfo.ticketType;
                    requestObj.arrivalInfo.isGroundTransport = isGroundTransport;
                    requestObj.arrivalInfo.tsa = arrivalInfo.arrivalTsa;

                }
                else {
                    if (
                        departureState.departureDate.get() === null
                    ) {
                        showError('error', 'Please select dates.')
                        return false;
                    }
                    departureInfo.eventID = eventInfo.eventID;
                    departureInfo = Helper.trimObject(departureInfo);
                    if (
                        departureInfo.departureAirport ==
                        departureInfo.arrivalAirport
                    ) {
                        showError('error', 'Arrival and departure airport should be different')
                        return false;
                    }
                    requestObj.departureInfo = departureInfo;
                    requestObj.departureInfo.airline =
                        departureInfo.departureAirline;
                    requestObj.departureInfo.flightNo =
                        departureInfo.departureFlightNo;
                    requestObj.departureInfo.comments =
                        departureInfo.departureComments;
                    requestObj.departureInfo.ticketType = departureInfo.ticketType;
                    requestObj.departureInfo.isGroundTransport = isGroundTransport;
                    requestObj.departureInfo.tsa = departureInfo.departureTsa;
                }
            }
        }
        
        // console.log(requestObj)
        // return false;
        if (
            currentTransportInfo.get() &&
            currentTransportInfo.get().draftTransportID > 0
        ) {
            requestObj.transportInfo =
                requestObj.departureInfo || requestObj.arrivalInfo;
            delete requestObj.arrivalInfo;
            delete requestObj.departureInfo;
            disableButton.set(true); 
            // console.log(requestObj);
            ApiHelper.post(APIURLConstants.POST_UPD_DRAFT_AIR_TRANSPORT, requestObj)
                .then(async (res) => {
                    if (res.data) {
                        showError('success', 'Request updated successfully')
                        let isPublished = participantList.filter(
                            (x) =>
                                x.isPublished === true &&
                                x.userID === requestObj.transportInfo.addedFor
                        );
                        await updateModuleState();
                        setTimeout(async () => {
                            resetState();
                            disableButton.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles &&
                                    Helper.isEventAdmin(userInfo)) ||
                                (userInfo.roles &&
                                    Helper.isEventStaff(userInfo))
                            ) {
                                props.history.goBack();
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.DRAFT_EVENT_TRANSIT, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    disableButton.set(false);
                    if (error.response && error.response.status === 401) {
                        showError('error', 'Access denied')
                    } else {
                        showError('error', 'Error while creating request')
                    }
                });
        } else {
            disableButton.set(true); 
            // console.log(requestObj);
            
            ApiHelper.post(APIURLConstants.POST_INS_DRAFT_AIR_TRANSPORT, requestObj)
                .then(async (res) => {
                    if (res.data) {
                        showError('success', 'Request added successfully')
                        await updateModuleState();
                        setTimeout(() => {
                            resetState();
                            disableButton.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles &&
                                    Helper.isEventAdmin(userInfo)) ||
                                (userInfo.roles &&
                                    Helper.isEventStaff(userInfo))
                            ) {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.DRAFT_EVENT_TRANSIT_LIST,
                                        { eventID: eventInfo.eventID }
                                    )
                                );
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.DRAFT_EVENT_TRANSIT, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    disableButton.set(false);
                    if (error.response && error.response.status === 401) {
                        showError('error', 'Access denied')
                    } else {
                        showError('error', 'Error while creating request')
                    }
                });
        }
    };

    const handleBtnCancel = () => {
        resetState();
        props.history.goBack();
    };

    const handleOnChange2 = (stateobj, field, value, index) => {
        if (field == 'passengerEmail') {
            stateobj[field].set(value);
            arrivalState['peopleInfo'][index][field].set(value);
            departureState['peopleInfo'][index][field].set(value);

        }
        else if (field == 'passengerContactNo') {
            stateobj[field].set(value);
            arrivalState['peopleInfo'][index][field].set(value);
            departureState['peopleInfo'][index][field].set(value);
        }
        else if (field == 'gender') {
            arrivalState['peopleInfo'][index][field].set(value);
            departureState['peopleInfo'][index][field].set(value);
        }
        else if (field == 'dob') {
            arrivalState['peopleInfo'][index][field].set(dayjs(value).format('YYYY-MM-DD'));
            departureState['peopleInfo'][index][field].set(dayjs(value).format('YYYY-MM-DD'));
            if (tripType.get() == 'round') {
                setDateDOBDisabled(true)
            }
        } else if (field == 'departureDate') {
            stateobj[field].set(value);
            stateobj['departureDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
        } else if (field == 'arrivalDate') {
            stateobj[field].set(value);
            stateobj['arrivalDate'].set(dayjs(value).format('YYYY-MM-DDTHH:mm'));
        } else if (field == 'departureTime') {
            stateobj[field].set(value);
        } else if (field == 'arrivalTime') {
            stateobj[field].set(value);
            stateobj['arrivalTime'].set(value);
        } else if (field == 'name') {
            stateobj[field].set(value);
            arrivalState['peopleInfo'][index][field].set(value);
            departureState['peopleInfo'][index][field].set(value);
        } else {
            stateobj[field].set(value);
        }
        handleDisableBtn();
    };

    const changeParticipant = (participant) => {
        if (participant) {
            arrivalState.peopleInfo[0]['name'].set('');
            departureState.peopleInfo[0]['name'].set('');
            getParticipantDob(participant.userID);
        } else {
            arrivalState.peopleInfo[0]['dob'].set(null);
            departureState.peopleInfo[0]['dob'].set(null);
            resetState();
        }
        setParticipant(participant);
    };

    const handleDisableBtn = () => {
        if (props.transitID > 0 && props.transitInfo) {
            const prevState = prevTransInfo.attach(Downgraded).get();
            let prevData = {
                ticketType: prevState.ticketType,
                totalPassengers: prevState.totalPassengers,
                peopleInfo: prevState.peopleInfo,
                departureAirport: prevState.departureAirport,
                arrivalAirport: prevState.arrivalAirport,
                departureDate: Helper.FormatDateOnly(prevState.departureDate),
                departureTime: Helper.FormatTime24(prevState.departureDate),
                arrivalDate: Helper.FormatDateOnly(prevState.arrivalDate),
                arrivalTime: Helper.FormatTime24(prevState.arrivalDate),
                arrivalAirline: prevState.airline,
                flightNo: prevState.flightNo,
                comments: prevState.comments,
                isPrivate: prevState.isPrivate,
                tsa: prevState.tsa,
                isGroundTransport: prevState.isGroundTransport,
                pickupAddress: prevState.groundPickupAddress,
                dropoffAddress: prevState.groundDropoffAddress,
            };

            const transportInfo = props.transitInfo;
            if (transportInfo.tripInfoType === 'arrival') {
                let peopleData = [];
                arrivalState.get().peopleInfo &&
                    arrivalState.get().peopleInfo.map((item) => {
                        let people = {
                            name: item.name,
                            dob: Helper.FormatDateOnly(item.dob),
                            passengerContactNo: item.passengerContactNo,
                            passengerEmail: item.passengerEmail,
                            gender: item.gender
                        };
                        peopleData.push(people);
                    });

                let currentData = {
                    ticketType: arrivalState.get().ticketType,
                    totalPassengers: arrivalState.get().totalPassengers,
                    peopleInfo: peopleData,
                    departureAirport: arrivalState.get().departureAirport,
                    arrivalAirport: arrivalState.get().arrivalAirport,
                    departureDate: Helper.FormatDateOnly(
                        arrivalState.get().departureDate
                    ),
                    departureTime: arrivalState.get().departureTime,
                    arrivalDate: Helper.FormatDateOnly(
                        arrivalState.get().arrivalDate
                    ),
                    arrivalTime: arrivalState.get().arrivalTime,
                    arrivalAirline: arrivalState.get().arrivalAirline,
                    flightNo: arrivalState.get().arrivalFlightNo,
                    comments: arrivalState.get().arrivalComments,
                    isPrivate: arrivalState.get().isPrivate,
                    tsa: arrivalState.get().arrivalTsa,
                    isGroundTransport: isGroundTransport,
                    pickupAddress: pickupAddress,
                    dropoffAddress: dropoffAddress
                };
                if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                    setDisableBtn(true);
                } else {
                    setDisableBtn(false);
                }
            } else {
                let peopleData = [];
                departureState.get().peopleInfo &&
                    departureState.get().peopleInfo.map((item) => {
                        let people = {
                            name: item.name,
                            dob: Helper.FormatDateOnly(item.dob),
                            passengerContactNo: item.passengerContactNo,
                            passengerEmail: item.passengerEmail,
                            gender: item.gender
                        };
                        peopleData.push(people);
                    });

                let currentData = {
                    ticketType: departureState.get().ticketType,
                    totalPassengers: departureState.get().totalPassengers,
                    peopleInfo: peopleData,
                    departureAirport: departureState.get().departureAirport,
                    arrivalAirport: departureState.get().arrivalAirport,
                    departureDate: Helper.FormatDateOnly(
                        departureState.get().departureDate
                    ),
                    departureTime: departureState.get().departureTime,
                    arrivalDate: Helper.FormatDateOnly(
                        departureState.get().arrivalDate
                    ),
                    arrivalTime: departureState.get().arrivalTime,
                    arrivalAirline: departureState.get().departureAirline,
                    flightNo: departureState.get().departureFlightNo,
                    comments: departureState.get().departureComments,
                    isPrivate: departureState.get().isPrivate,
                    tsa: departureState.get().departureTsa
                };
                if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                    setDisableBtn(true);
                } else {
                    setDisableBtn(false);
                }
            }
        }
    };

    const onCheckGroundTranport = (value) => { 
        setIsGroundTransport(value)
    } 
    
    return (
        <>
            <Box
                component="form"
                sx={{                    
                    width: '100%',
                    '& .MuiGrid-item': { p: 1 },
                }}
                onSubmit={handleSubmit}>
                <Card sx={{ boxShadow: 'none' }}>
                    <CardContent classes={{ root: classes.contentRoot }}>
                        <Grid container sx={{ alignItems: 'center' }}>
                            <Grid item lg={8} md={8} xs={12}>
                                <Box className={classes.titleContent}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}>
                                        <AirTransportIcon
                                            style={{
                                                width: '60px',
                                                height: '60px',
                                            }}
                                        />
                                        <Title
                                            title="Air Travel"
                                            sx={{
                                                ml: 1,
                                                fontSize: '30px',
                                            }}
                                        />
                                    </Paper>
                                    
                                    <Paper
                                        elevation={0}
                                        className={classes.selectionContent}>
                                        {
                                            <>
                                                <Box
                                                    sx={{
                                                        width: '100%',                                                        
                                                        display: 'flex',
                                                    }}>
                                                    <Checkbox       
                                                        disabled={
                                                            props.transitID == 0
                                                                ? false
                                                                : true
                                                        }                                                  
                                                        checked={isGroundTransport}
                                                        className={
                                                            classes.checkbox_style
                                                        }
                                                        onChange={(e) => {
                                                            onCheckGroundTranport(e.target.checked)
                                                            handleDisableBtn()
                                                        }
                                                        }
                                                        value={isGroundTransport}
                                                    />

                                                    <Typography sx={{ mt: 1 }}>
                                                        Click here if you are local and only ground transportation needed
                                                    </Typography>
                                                </Box>
                                               {!isGroundTransport && <RadioGroup
                                                    row
                                                    aria-label="tripType"
                                                    name="tripType"
                                                    value={tripType.get()}
                                                    onChange={(event) =>
                                                        tripType.set(
                                                            event.target.value
                                                        )
                                                    }>
                                                    <FormControlLabel
                                                        value="oneway"
                                                        control={
                                                            <Radio
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        }
                                                        label="One Way"
                                                        disabled={
                                                            props.transitID == 0
                                                                ? false
                                                                : true
                                                        }
                                                        style={{marginLeft:0}}
                                                    />
                                                    <FormControlLabel
                                                        value="round"
                                                        control={
                                                            <Radio
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        }
                                                        label="Round Trip"
                                                        disabled={
                                                            props.transitID == 0
                                                                ? false
                                                                : true
                                                        }
                                                    />
                                                </RadioGroup>}
                                            </>
                                        }
                                        {tripType.get() === 'oneway' && !isGroundTransport ? (
                                            <RadioGroup
                                                row
                                                aria-label="infoType"
                                                name="infoType"
                                                value={infoType.get()}
                                                    onChange={(event) => {
                                                        setDateDOBDisabled(false)
                                                        infoType.set(
                                                            event.target.value
                                                        )
                                                    }
                                                }>
                                                <FormControlLabel
                                                    value="arrival"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Arrival Info"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                    style={{marginLeft:0}}
                                                />
                                                <FormControlLabel
                                                    value="departure"
                                                    control={
                                                        <Radio
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label="Departure Info"
                                                    disabled={
                                                        props.transitID == 0
                                                            ? false
                                                            : true
                                                    }
                                                />
                                            </RadioGroup>
                                        ) : null}
                                    </Paper>
                                </Box>
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <ParticipantAutoList
                                    disableParticipant={
                                        props.transitInfo &&
                                            props.transitInfo.draftAirTransportID
                                            ? true
                                            : false
                                    }
                                    participant={participant}
                                    setParticipant={changeParticipant}
                                    participantList={props.participantList}
                                    modPermission={props.modPermission}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    style={{ marginLeft: 0, marginTop: 0, width: '100%' }}>
                    {(tripType.get() === 'oneway' && 
                        infoType.get() == 'arrival') ||
                        tripType.get() === 'round' ? !isGroundTransport && (
                        <Grid item lg={6} md={12} xs={12}>
                            <AppBarHeader
                                title="Event Arrival Information"
                                icon="land"
                            />

                            {/* <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}> */}
                                {/* <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        type1="title"
                                        label1="Number of people travelling"
                                        value1=""
                                        required1={false}
                                        type2="select"
                                        // disabled2={true}
                                        label2="Number of people travelling"
                                        required2={true}
                                        value2={arrivalState.totalPassengers.get()}
                                        stateobj={arrivalState}
                                        field2="totalPassengers"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid> */}
                                {/* <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        //type1="title"
                                        index={0}
                                        label1="Ticket Type"
                                        //value1=""
                                        //required1={true}
                                        type2="ticketSelect"
                                        disabled2={
                                            props.transitID > 0
                                                ? !Helper.isAdminUser(
                                                    userInfo.get()
                                                ) &&
                                                    !(
                                                        userInfo.get().roles &&
                                                        Helper.isEventAdmin(
                                                            userInfo.get()
                                                        )
                                                    )
                                                    ? true
                                                    : true
                                                : false
                                        }
                                        label2="Ticket Type"
                                        required2={true}
                                        value2={arrivalState.ticketType.get()}
                                        stateobj={arrivalState}
                                        field2="ticketType"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid> */}
                            {/* </Grid> */}
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '.7rem',
                                    color: 'red',
                                    pl: 2.5,
                                }}
                                h5>
                                {' '}
                                Legal Name as it appears on your ID
                                {/* (for the purposes of booking your flight) */}
                            </Typography>
                            {arrivalState.peopleInfo.get() &&
                                arrivalState.peopleInfo.get().length > 0
                                ? arrivalState.peopleInfo
                                    .get()
                                    .map((item, index) => (
                                        <>
                                            <Grid
                                                key={`arrive_person_${index}`}
                                                item
                                                container
                                                direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                    md: 'row',
                                                    lg: 'row',
                                                }}>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Passenger Name"
                                                        value1=""
                                                        required1={false}
                                                        type2="text"
                                                        label2="Passenger Name"
                                                        required2={true}
                                                        value2={arrivalState.peopleInfo[
                                                            index
                                                        ]['name'].get()}
                                                        field2="name"
                                                        stateobj={arrivalState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                        personErr={arrivalState.peopleInfo[
                                                            0
                                                        ]['err'].get()}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="DOB"
                                                        required1={false}
                                                        label2="DOB"
                                                        type2="date"
                                                        required2={false}
                                                        value2={
                                                            arrivalState
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get().peopleInfo[
                                                            index
                                                            ]['dob']
                                                        }
                                                        stateobj={arrivalState}
                                                        field2="dob"
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                // key={`arrive_person_${index}`}
                                                item
                                                container
                                                direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                    md: 'row',
                                                    lg: 'row',
                                                }}>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="pnumber"
                                                        label1="Passenger Contact No*"
                                                        value1=""
                                                        required1={false}
                                                        type2="pnumber"
                                                        label2="Passenger Contact No*"
                                                        required2={true}
                                                        value2={arrivalState.peopleInfo[
                                                            index
                                                        ]['passengerContactNo'].get()}
                                                        field2="passengerContactNo"
                                                        stateobj={arrivalState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    // personErr={arrivalState.peopleInfo[
                                                    //     0
                                                    // ]['err'].get()}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Passenger Email"
                                                        required1={true}
                                                        label2="Passenger Email"
                                                        type2="text"
                                                        required2={true}
                                                        value2={
                                                            arrivalState
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get().peopleInfo[
                                                            index
                                                            ]['passengerEmail']
                                                        }
                                                        stateobj={arrivalState}
                                                        field2="passengerEmail"
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Gender"
                                                        value1={arrivalState.peopleInfo[
                                                            index
                                                        ]['gender'].get()}
                                                        required1={false}
                                                        type2="genderSelect"
                                                        label2="Gender"
                                                        genderType={genderType.attach(Downgraded).get()}
                                                        required2={true}
                                                        value2={arrivalState.peopleInfo[
                                                            index
                                                        ]['gender'].get()}
                                                        field2="gender"
                                                        stateobj={arrivalState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    // personErr={arrivalState.peopleInfo[
                                                    //     0
                                                    // ]['err'].get()}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </>
                                    ))
                                : null}
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="     Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Departure Airport"
                                        required2={true}
                                        value2={arrivalState.departureAirport.get()}
                                        stateobj={arrivalState}
                                        field2="departureAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Arrival Airport"
                                        required2={true}
                                        value2={arrivalState.arrivalAirport.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Date*"
                                        required1={false}
                                        type2="date"
                                        label2="Date*"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        fromDates={fromDates}
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().arrivalDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={arrivalState}
                                        field2="arrivalDate"
                                        tripInfoType="arrival"
                                        onChange2={handleOnChange2}
                                        dateDisabled={dateDisabled}
                                        disableallDates={disableallDates}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Preferred Time of Arrival*"
                                        required1={false}
                                        type2="time"
                                        label2="Preferred Time of Arrival*"
                                        required2={false}
                                        value2={
                                            arrivalState
                                                .attach(Downgraded)
                                                .get().arrivalTime
                                        }
                                        stateobj={arrivalState}
                                        field2="arrivalTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Preferred Airline"
                                        required1={false}
                                        type2="text"
                                        label2="Preferred Airline"
                                        required2={false}
                                        value2={arrivalState.arrivalAirline.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalAirline"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={
                                            (arrivalState.isPrivate.get() === true || departureState.isPrivate.get() === true)
                                                ? 'Tail No.'
                                                : 'Frequent Flyer'
                                        } 
                                        type2="text"
                                        label2={
                                            (arrivalState.isPrivate.get() === true || departureState.isPrivate.get() === true)
                                                ? 'Tail No.'
                                                : 'Frequent Flyer'
                                        } 
                                        value2={arrivalState.arrivalFlightNo.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalFlightNo"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={'TSA'} 
                                        type2="text"
                                        label2={'TSA'}                                        
                                        value2={arrivalState.arrivalTsa.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalTsa"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="arrivaltext"
                                        label1="Comments"
                                        required1={false}
                                        type2="arrivaltext"
                                        label2="Comments"
                                        required2={false}
                                        value2={arrivalState.arrivalComments.get()}
                                        stateobj={arrivalState}
                                        field2="arrivalComments"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                    ) : null}
                    {(tripType.get() === 'oneway' && 
                        infoType.get() == 'departure') ||
                        tripType.get() === 'round' ? !isGroundTransport && (
                        <Grid item lg={6} md={12} xs={12}>
                            <AppBarHeader
                                title="Event Departure Information"
                                icon="takeoff"
                            />

                            {/* <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        type1="title"
                                        label1="Number of people travelling"
                                        required1={false}
                                        type2="select"
                                        // disabled2={true}
                                        label2="Number of people travelling"
                                        required2={true}
                                        value2={departureState.totalPassengers.get()}
                                        stateobj={departureState}
                                        field2="totalPassengers"
                                        onChange2={handleOnChange2}
                                        inputProps={{
                                            inputProps: {
                                                max: 3,
                                                min: 1,
                                            },
                                        }}
                                    />
                                </Grid> 
                                 <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="space-around"
                                        //type1="title"
                                        label1="Ticket Type"
                                        // value1=""
                                        index={0}
                                        //required1={true}
                                        type2="ticketSelect"
                                        disabled2={
                                            props.transitID > 0
                                                ? !Helper.isAdminUser(
                                                    userInfo.get()
                                                ) &&
                                                    !(
                                                        userInfo.get().roles &&
                                                        Helper.isEventAdmin(
                                                            userInfo.get()
                                                        )
                                                    )
                                                    ? true
                                                    : true
                                                : false
                                        }
                                        label2="Ticket Type"
                                        required2={true}
                                        value2={departureState.ticketType.get()}
                                        stateobj={departureState}
                                        field2="ticketType"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid> 
                            </Grid>*/}
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '.7rem',
                                    color: 'red',
                                    pl: 2.5,
                                }}
                                h5>
                                {' '}
                                Legal Name as it appears on your ID
                                {/* (for the purposes of booking your flight) */}
                            </Typography>
                            {departureState.peopleInfo.get() &&
                                departureState.peopleInfo.get().length > 0
                                ? departureState.peopleInfo
                                    .get()
                                    .map((item, index) => (
                                        <>
                                            <Grid
                                                key={`depart_person_${index}`}
                                                item
                                                container
                                                direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                    md: 'row',
                                                    lg: 'row',
                                                }}>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`depart_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Passenger Name"
                                                        required1={false}
                                                        type2="text"
                                                        label2="Passenger Name"
                                                        required2={true}
                                                        value2={departureState.peopleInfo[
                                                            index
                                                        ]['name'].get()}
                                                        field2="name"
                                                        stateobj={departureState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                        personErr={departureState.peopleInfo[
                                                            0
                                                        ]['err'].get()}
                                                    />
                                                </Grid>

                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`depart_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="DOB"
                                                        required1={false}
                                                        label2="DOB"
                                                        type2="date"
                                                        required2={false}
                                                        value2={
                                                            departureState
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get().peopleInfo[
                                                            index
                                                            ]['dob']
                                                        }
                                                        stateobj={departureState}
                                                        field2="dob"
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                        dateDisabled={dateDOBDisabled}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                // key={`arrive_person_${index}`}
                                                item
                                                container
                                                direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                    md: 'row',
                                                    lg: 'row',
                                                }}>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="pnumber"
                                                        label1="Passenger Contact No*"
                                                        value1=""
                                                        required1={false}
                                                        type2="pnumber"
                                                        label2="Passenger Contact No*"
                                                        required2={true}
                                                        value2={departureState.peopleInfo[
                                                            index
                                                        ]['passengerContactNo'].get()}
                                                        field2="passengerContactNo"
                                                        stateobj={departureState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    // personErr={departureState.peopleInfo[
                                                    //     0
                                                    // ]['err'].get()}
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Passenger Email"
                                                        required1={false}
                                                        label2="Passenger Email"
                                                        type2="text"
                                                        required2={true}
                                                        value2={
                                                            departureState
                                                                .attach(
                                                                    Downgraded
                                                                )
                                                                .get().peopleInfo[
                                                            index
                                                            ]['passengerEmail']
                                                        }
                                                        stateobj={departureState}
                                                        field2="passengerEmail"
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs>
                                                    <FieldContainer
                                                        {...props}
                                                        item={item}
                                                        index={index}
                                                        key={`arrival_people_${index}`}
                                                        justifyContent="center"
                                                        type1="title"
                                                        label1="Gender"
                                                        value1=""
                                                        required1={false}
                                                        type2="genderSelect"
                                                        genderType={genderType.attach(Downgraded).get()}
                                                        label2="Gender"
                                                        required2={true}
                                                        value2={departureState.peopleInfo[
                                                            index
                                                        ]['gender'].get()}
                                                        field2="gender"
                                                        stateobj={departureState}
                                                        onChange2={
                                                            handleOnChange2
                                                        }
                                                    // personErr={departureState.peopleInfo[
                                                    //     0
                                                    // ]['err'].get()}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </>
                                    ))
                                : null}
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Departure Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Departure Airport"
                                        required2={true}
                                        value2={departureState.departureAirport.get()}
                                        stateobj={departureState}
                                        field2="departureAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Arrival Airport"
                                        required1={false}
                                        type2="text"
                                        label2="Arrival Airport"
                                        required2={true}
                                        value2={departureState.arrivalAirport.get()}
                                        stateobj={departureState}
                                        field2="arrivalAirport"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Date*"
                                        required1={false}
                                        type2="date"
                                        label2="Date*"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        toDates={toDates}
                                        required2={true}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().departureDate
                                        }
                                        // disableDate={isDateDisable}
                                        stateobj={departureState}
                                        field2="departureDate"
                                        tripInfoType="departure"
                                        onChange2={handleOnChange2}
                                        disableallDates={disableallDates}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Preferred Time of Departure*"
                                        required1={false}
                                        type2="time"
                                        label2="Preferred Time of Departure*"
                                        required2={false}
                                        value2={
                                            departureState
                                                .attach(Downgraded)
                                                .get().departureTime
                                        }
                                        stateobj={departureState}
                                        field2="departureTime"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1="Preferred Airline"
                                        required1={false}
                                        type2="text"
                                        label2="Preferred Airline"
                                        required2={false}
                                        value2={departureState.departureAirline.get()}
                                        stateobj={departureState}
                                        field2="departureAirline"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={
                                            (arrivalState.isPrivate.get() === true || departureState.isPrivate.get() === true)
                                                ? 'Tail No.'
                                                : 'Frequent Flyer'
                                        }
                                        required1={false}
                                        type2="text"
                                        label2={
                                            (arrivalState.isPrivate.get() === true || departureState.isPrivate.get() === true)
                                                ? 'Tail No.'
                                                : 'Frequent Flyer'
                                        }
                                        required2={false}
                                        value2={departureState.departureFlightNo.get()}
                                        stateobj={departureState}
                                        field2="departureFlightNo"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="title"
                                        label1={'TSA'}
                                        required1={false}
                                        type2="text"
                                        label2={'TSA'}
                                        required2={false}
                                        value2={departureState.departureTsa.get()}
                                        stateobj={departureState}
                                        field2="departureTsa"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                container
                                direction={{
                                    xs: 'column',
                                    sm: 'row',
                                    md: 'row',
                                    lg: 'row',
                                }}>
                                <Grid item xs>
                                    <FieldContainer
                                        {...props}
                                        justifyContent="center"
                                        type1="departuretext"
                                        label1="Comments"
                                        required1={false}
                                        type2="departuretext"
                                        label2="Comments"
                                        required2={false}
                                        value2={departureState.departureComments.get()}
                                        stateobj={departureState}
                                        field2="departureComments"
                                        onChange2={handleOnChange2}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                    ) : null}
                    {isGroundTransport && (<Grid item lg={12} md={12} xs={12}>
                        <Grid
                            item
                            container
                            direction={{
                                xs: 'column',
                                sm: 'row',
                                md: 'row',
                                lg: 'row',
                            }}>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    required
                                    id="outlined-required"
                                    label="Pickup Address"
                                    value={pickupAddress}
                                    onChange={(event) => {
                                        setPickupAddress(event.target.value);
                                        setDisableBtn(false);
                                        // handleDisableBtn()
                                    }}
                                    multiline={true}
                                    minRows={3}
                                    maxRows={10}
                                    inputProps={{ maxLength: 260 }}
                                /> 
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    required
                                    id="outlined-required"
                                    label="Drop-off Address"
                                    value={dropoffAddress}
                                    onChange={(event) => {
                                        setDropoffAddress(event.target.value);
                                        setDisableBtn(false);
                                        // handleDisableBtn()
                                    }}
                                    multiline={true}
                                    minRows={3}
                                    maxRows={10}
                                    inputProps={{ maxLength: 260 }}
                                />
                                </Grid>
                        </Grid>
                    </Grid>)}
                    <Divider component="div" />
                    {(tripType.get() === 'oneway' &&
                        (infoType.get() == 'departure' ||
                            infoType.get() == 'arrival')) ||
                        tripType.get() === 'round' ? (
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                            <ButtonContainer
                                // handleClick={handleBtnClick}
                                handleCancel={handleBtnCancel}
                                buttonText={
                                    props.transitID > 0 ? 'Update' : 'Create'
                                }
                                disableButton={disableButton.get()}
                                disableUpdateButton={
                                    props.transitID > 0 ? disableBtn : false
                                }
                            />
                        </Grid>
                    ) : null}
                </Grid>
            </Box>
        </>
    );
};
export default AirTransport;
